export const TokenIOutlookSettingsRepository = "IOutlookSettingsRepository";

export interface IOutlookSettingsRepository {
    GetAppSetting(key: string): any;
    SetAppSetting(key: string, value: any): boolean;
    GetOutlookLanguage(): string;
    GetTimeZoneOffset(): number;
    NotificationMessages(id: string, details: any, handleResult: any): void;
    GetOutlookTheme(): string;
} 